<template>
  <el-row style="padding: 1rem; width: 100%;height:100%" class="center">
    <Breadcrumb v-if="page && page.showBreadcrumb" :curr="page.name" />
    <el-input v-if="page && page.layout == '检索框'" style="margin-bottom: 2rem; width: 50rem" autofocus
      @keyup.enter.native="homeSearch" v-model="home.keyword" clearable>
      <el-button type="primary" slot="append" icon="el-icon-search" @click="homeSearch" />
    </el-input>
    <el-row v-if="page && page.layout == '横向' && modules.length">
      <Module :id="modules[0].id" :paras="paras" />
      <el-tabs v-model="firstModuleCode">
        <el-tab-pane v-for="md in tabData" :key="md.id" :label="md.name" :name="md.code">
          <Module :id="md.id" :paras="paras" />
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row v-else-if="page" style="height:100%">
      <el-row v-for="md in sortedModules" :key="md.id" style="height:100%">
        <Module :id="md.id" :paras="paras" />
      </el-row>
    </el-row>
    <el-row v-else-if="isEmpty">
      <span class="danger">页面配置不存在！</span>
    </el-row>
    <el-skeleton v-else :rows="6" animated> </el-skeleton>
  </el-row>
</template>

<script>
import api from "./api";
import { mapGetters } from "sw-hic";

export default {
  components: {
    Breadcrumb: () => import("./_breadcrumb"),
    Module: () => import("./module.vue"),
  },
  data() {
    return {
      page: null,
      roles: [],
      modules: [],
      paras: {},
      home: {
        keyword: null,
        targetCode: null,
      },
      firstModuleCode: null,
      isEmpty: false,
    };
  },
  computed: {
    ...mapGetters(["permission", "user", "userRoles", "dict"]),
    tabData() {
      if (this.modules.length < 2) {
        return [];
      }
      this.firstModuleCode = this.sortedModules[1].code;
      return this.sortedModules.filter((m) => m.id != this.modules[0].id);
    },
    sortedModules() {
      return this.modules.sort((a, b) => a.order - b.order);
    },
  },
  watch: {
    "$route.query.code"() {
      this.init();
    },
  },
  mounted() {
    this.getUserRoles();
    // this.init();
  },
  methods: {
    getUserRoles() {
      api.Staff.queryRole(this.user.id).then((res) => {
        this.$store.commit("setUserRoles", res.items);
        this.init();
      });
    },
    init() {
      if (this.user.forSys && this.$route.name != "viewer") {
        // 如果嵌入第三方画面，此处转发
        this.$router.replace({ name: "viewer", query: { code: this.$route.query.code, paras: this.$route.query.paras } });
        return;
      }
      this.modules = [];
      if (this.$route.query.paras) {
        this.paras = JSON.parse(this.$route.query.paras);
      }
      api.Page.query({ code: this.$route.query.code }).then((res) => {
        if (!res.items.length) {
          this.isEmpty = true;
          return;
        }
        this.isEmpty = false;
        this.page = res.items[0];
        if (this.page.layout == "检索框") {
          this.homeInit();
        }
        this.roles = JSON.parse(this.page.roles);

        if (!this.checkRoles(this.roles)) return this.$message.error("没有权限访问该页面");
        this.modules = JSON.parse(this.page.modules);
        // let mds = JSON.parse(this.page.modules);
        // mds.forEach((md) => {
        //   let mod = this.$utils.clone(this.dict.WebModule.find((m) => m.id == md.id));
        //   let roles = JSON.parse(res.roles);
        //   mod.order = md.order;
        //   if (this.checkRoles(roles)) this.modules.push(mod);
        //   else this.$message.error("无权限访问模块：" + mod.name);
        // });

        api.Log.save({
          doctorCode: this.user.code,
          doctorName: this.user.name,
          deptCode: this.user.deptCode,
          deptName: this.user.deptName,
          url: this.$route.fullPath,
          paras: this.$route.query.paras,
          pageCode: this.page.code,
          pageName: this.page.name,
          moduleCodes: JSON.stringify(this.modules.map((m) => ({ code: m.code, name: m.name }))),
        });
      });
    },
    checkRoles(roles) {
      if (!roles.length) {
        return true;
      }
      return roles.findIndex((r) => this.userRoles.findIndex((ur) => (ur.roleCode = r.code)) >= 0) >= 0;
    },
    homeSearch() {
      if (this.home.targetCode) {
        this.$router.push({ name: "dynamic", query: { code: this.home.targetCode, paras: JSON.stringify({ keyword: this.home.keyword }) } });
        this.init();
      }
    },
    homeInit() {
      api.SiteMap.query({ srcCode: "home" })
        .then((res) => {
          if (!res.items.length) {
            throw "首页查询没有配置目标页！";
          }
          this.home.targetCode = res.items[0].tgtCode;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>
